<template>
    <div :class="[
        (type === 'info') ? 'bg-blue-50 border border-t-blue-800 border-t-4 border-blue-400' :
        (type === 'warning') ? 'bg-yellow-50 border border-t-yellow-800 border-t-4 border-yellow-400' : 
        (type === 'error') ? 'bg-red-50 border border-t-red-800 border-t-4 border-red-400' : '','rounded py-4 px-2 mt-3 ' + custom_class
        ]">
        <div class="flex">
            <div class="flex-shrink-0">
                <font-awesome-icon
                    v-if="type === 'info'"
                    :icon="faCircleInfo"
                    class="h-5 w-5 text-blue-800"
                    aria-hidden="true"
                />
                <font-awesome-icon
                    v-if="type === 'warning'"
                    :icon="faExclamationTriangle"
                    class="h-5 w-5 text-yellow-800"
                    aria-hidden="true"
                />
                <font-awesome-icon
                    v-if="type === 'error'"
                    :icon="faOctagonExclamation"
                    class="h-5 w-5 text-red-800"
                    aria-hidden="true"
                />
            </div>
            <div class="ml-3 flex-1 md:flex md:justify-between">
                <div :class="
                    [ (type === 'info') ? 'text-blue-800' :
                    (type === 'warning') ? 'text-yellow-800' : 
                    (type === 'error') ? 'text-red-800' : '','text-sm w-full'
                    ]"
                >
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps } from 'vue';
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {
    faCircleInfo,
    faExclamationTriangle,
    faOctagonExclamation
} from "@fortawesome/pro-solid-svg-icons";

defineProps({
    type: {
        type: String,
        required: true,
        validator: (value) => ['info', 'warning', 'error'].includes(value),
    },
    custom_class: String,
});
</script>
